/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2023-12-19 14:06:30
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2024-01-02 16:00:08
 * @FilePath     : /ticket-plat-frontend/src/config/index.ts
 */
import devConfig from './development';
import onlineConfig from './online';
import sandboxConfig from './sandbox';
import xsDevelopmentConfig from './xsDevelopment';
import xsOnlineConfig from './xsOnline';
import xsSandboxConfig from './xsSandbox';

export interface ENV_CONFIG {
    MATCHER: RegExp;
    IS_XS: boolean; // 是否是虚商环境
    MOBILE_TICKET_HOST: string;
    TOOLS_HOST: string; // 自助服务
    TOOL_HOST: string;
    CONSOLE_HOST: string;
    CLOUD_HOST: string;
    CONSOLE_LOGIN_HOST: string; // 智能云控制台登录页
    VOC_HOST: string; // 云音
    ZNZS_HOST: string; // 智能助手
    ZNZS_H5_HOST: string;
    ZNZS_H5_WINDOW_URL: string; // 浮窗打开小助手拦截地址
    APP_TAG: string; // 埋点 appTag
    ACA_HOST: string; // 云顾问
    SUPPORT_HOST: string; // 服务与支持
}

export enum DEPLOY_ENV {
    development = 'development', // 本地开发
    sandbox = 'sandbox', // 测试环境
    online = 'online', // 预生产/生产环境
    xsDevelopment = 'xsDevelopment', // 虚商本地开发
    xsSandbox = 'xsSandbox', // 虚商测试环境
    xsOnline = 'xsOnline', // 虚商预生产/生产环境
}

// 生成 env 配置
// 线上分支有些情况下也要在 测试、预生产部署测试，所以才用 href 来判断环境
let ENV: DEPLOY_ENV = DEPLOY_ENV.online;
const href = location.host || '';
if (onlineConfig.MATCHER.test(href)) {
    ENV = DEPLOY_ENV.online;
}
else if (sandboxConfig.MATCHER.test(href)) {
    ENV = DEPLOY_ENV.sandbox;
}
else if (devConfig.MATCHER.test(href)) {
    ENV = DEPLOY_ENV.development;
}
else if (xsOnlineConfig.MATCHER.test(href)) {
    ENV = DEPLOY_ENV.xsOnline;
}
else if (xsSandboxConfig.MATCHER.test(href)) {
    ENV = DEPLOY_ENV.xsSandbox;
}
else if (xsDevelopmentConfig.MATCHER.test(href)) {
    ENV = DEPLOY_ENV.xsDevelopment;
}

export {ENV};
export default {
    [DEPLOY_ENV.development]: devConfig,
    [DEPLOY_ENV.sandbox]: sandboxConfig,
    [DEPLOY_ENV.online]: onlineConfig,
    [DEPLOY_ENV.xsDevelopment]: xsDevelopmentConfig,
    [DEPLOY_ENV.xsSandbox]: xsSandboxConfig,
    [DEPLOY_ENV.xsOnline]: xsOnlineConfig,
}[ENV] || {};

